<template>
  <b-row>
    <b-col lg="3" md="3" sm="12" order="1">
      <b-card class="sticky-card">
        <h5 class="kb-title">
          <b-icon icon="info-circle" class="mr-1" />
          Covered Topics
        </h5>
        <vue-perfect-scrollbar :settings="scrollSettings" class="scroll-style">
          <ul class="mt-1">
            <li v-for="(topic, index) in relatedTopics" :key="index" class="ml-n2">
              <b-link :href="`#${topic.href}`" class="list-item">{{ topic.name }}</b-link>
            </li>
          </ul>
        </vue-perfect-scrollbar>
      </b-card>
    </b-col>
    <b-col lg="9" md="9" sm="12" order="2">
      <b-card>
        <h1 class="mb-1" align="center">Applications Dashboard</h1>
        <div class="question-content">
          <ApplicationsGuideContent></ApplicationsGuideContent>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import ApplicationsGuideContent from '@/xvisor/views/knowledgeBase/components/ApplicationsGuideContent.vue';

export default {
  components: {
    ApplicationsGuideContent,
    VuePerfectScrollbar,
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 50,
      },
      relatedTopics: [
        { name: 'Applications Summary Page', href: '1-applications-summary-page' },
        { name: 'Application Details Page', href: '2-application-details-page' },
        { name: 'Overview Tab', href: '2-1-overview-tab' },
        { name: 'Users Tab', href: '2-2-users-tab' },
        { name: 'Transactions Tab', href: '2-3-transactions-tab' },
        { name: 'Flows Tab', href: '2-4-flows-tab' },
        { name: 'Network Tab', href: '2-5-network-tab' },
        { name: 'Alerts Panel', href: '2-6-alerts-panel' },
      ],
    };
  },
};
</script>
